import { router } from '../index';

/**
 * Patches the global `fetch` to redirect to /auth/login on HTTP 401.
 * Auth endpoints (/api/v2/auth/) are excluded so that login failures are
 * handled normally by the login page.
 */
export function setupAuthInterceptor() {
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401) {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";
      const isAuthEndpoint = url.includes("/api/v2/auth/");

      if (!isAuthEndpoint) {
        router.navigate('/auth/login', { replace: true });
      }
    }

    return response;
  };
}
